/** An illustrative brief, never an invented client/order/income claim. */
export function renderFreelanceProofMarkup(): string {
 return `<div class="freelance-commission" aria-label="Пример работы над 3D-заказом">
   <div class="freelance-commission__scene" data-freelance-cube-stage role="img" aria-label="Игровой мост: от конструкции до готовой модели"></div>
   <ul class="freelance-commission__script" aria-label="От работы к оплате">
     <li data-freelance-step="0">Выполни работу<br><span>с помощью Blender Bridge</span></li>
     <li data-freelance-step="1">Передай результат</li>
     <li data-freelance-step="2">Получи оплату</li>
   </ul>
   <p class="freelance-commission__ending">Превращай навыки в оплачиваемую работу</p>
 </div>`;
}
